import { render } from "./WorkingSiteDocuments.vue?vue&type=template&id=56b9ef88&scoped=true&ts=true&lang=pug"
import script from "./WorkingSiteDocuments.vue?vue&type=script&lang=ts"
export * from "./WorkingSiteDocuments.vue?vue&type=script&lang=ts"

import "./WorkingSiteDocuments.vue?vue&type=style&index=0&id=56b9ef88&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b9ef88"]])

export default __exports__